import React from "react";

export default function ScanToStartSvgIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="115"
            height="115"
            viewBox="0 0 115 115"
            {...props}
        >
            <g transform="translate(-26 -45)">
                <circle
                    cx="57.5"
                    cy="57.5"
                    r="57.5"
                    transform="translate(26 45)"
                    fill={props.stopColor}
                />
                <g transform="translate(56 75)">
                    {/* QR Code Scanner Icon */}
                    <path
                        d="M0 4C0 1.79086 1.79086 0 4 0H12V4H4V12H0V4Z"
                        fill={props.fill}
                    />
                    <path
                        d="M0 51V43H4V51H12V55H4C1.79086 55 0 53.2091 0 51Z"
                        fill={props.fill}
                    />
                    <path
                        d="M51 0H43V4H51V12H55V4C55 1.79086 53.2091 0 51 0Z"
                        fill={props.fill}
                    />
                    <path
                        d="M51 55H43V51H51V43H55V51C55 53.2091 53.2091 55 51 55Z"
                        fill={props.fill}
                    />
                    {/* QR Code Pattern */}
                    <rect x="10" y="10" width="14" height="14" rx="2" fill={props.fill} />
                    <rect x="31" y="10" width="14" height="14" rx="2" fill={props.fill} />
                    <rect x="10" y="31" width="14" height="14" rx="2" fill={props.fill} />
                    <rect x="31" y="31" width="8" height="8" rx="1" fill={props.fill} />
                    <rect x="42" y="31" width="3" height="14" rx="1" fill={props.fill} />
                    <rect x="31" y="42" width="14" height="3" rx="1" fill={props.fill} />
                </g>
            </g>
        </svg>
    );
}
